<div>
  <div class="ta_center">
    <img class="m-b-24 robo-icon-cls" [src]="images.WAITING" alt="Waiting" />
     <div class="minimize-cls pos-min-icon " (click)="miniMize()"><img  [src]="images.MINIMINZE" alt="minimize" /></div>
     <div *ngIf="showInfoText" class="min-info">{{'SHARED.MINI_MIZE_POPUP_TEXT' | fallbackTranslate}}</div>
    <div>
      <span class="title">{{ 'SHARED.WAITING_TITLE' | fallbackTranslate }} ({{currency}} {{amount?.toFixed(2)}})</span>
    </div>
    <div class="sub-title m-t-5">
      {{ 'SHARED.WAITING_SUBTITLE' | fallbackTranslate }}
    </div>
    <div class="waiting-cls fs-16 m-t-5">{{ 'SHARED.WAITING_TEXT' | fallbackTranslate }}</div>
    <div class="flex align_center m-l-20 m-r-20 m-t-15 m-b-15">
      <div class="wd-95 m-r-5">  
      <nz-progress
        [nzPercent]="percentageElapsed"
        [nzShowInfo]="false"
        class="flex-1"
      ></nz-progress>
      </div>
      <nz-countdown [nzValue]="deadlineDate" [nzFormat]="'mm:ss'"></nz-countdown> <div class="p-l-5 black-clr fw-600">mins</div>
    </div>
    <div class="waiting-cls fs-14 m-t-5">{{ 'SHARED.WAITING_SUBTEXT' | fallbackTranslate }}</div>
    <p class="cancel fs-16 fw-400 m-t-5 p-b-13" (click)="cancelPayment()">{{ 'SHARED.CANCEL_PMT_LINK' | fallbackTranslate }}</p>
    <div *ngIf="showStaffGuide" class="staff-guide">
      <div class="flex flex_row">
        <img [src]="images.PINE_LAB_TERMINAL" alt="image" class="img-cls"/>
        <div class="m-10 flex flex_column wd-100">
           <div class="fs-15 fw-600 text-initiale">{{'SHARED.PINE_LAB_STEPS' | fallbackTranslate}}</div>
           <div class="flex flex_row  m-t-5">
             <div (click)="hideStaffGuide()" class="flex flex-center btn-cls p-5 iknow-cls">{{'SHARED.NO_I_KNOW' | fallbackTranslate}}</div>
             <div (click)="yesIwantToSee()" class="flex flex-center  btn-cls p-5 m-l-20 wanttosee-cls">{{'SHARED.YES_WANT_TO_SEE' | fallbackTranslate}}</div>
           </div>
        </div>
      </div>  
    </div>
  </div>
</div>
